import { render, staticRenderFns } from "./DownloadPDFModal.vue?vue&type=template&id=0ca2c71e"
import script from "./DownloadPDFModal.vue?vue&type=script&lang=js"
export * from "./DownloadPDFModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports